import { Page } from "src/dtos/Tmd.dtos";

export const
    ToggleHelpDrawer: IToggleHelpDrawerActionCreator = (isOpen) => {
        return {
            type: ACTION_TOGGLE_HELP_DRAWER,
            isOpen
        }
    },
    SetPage: ISetPageActionCreator = (page) => {
        return {
            type: ACTION_SET_PAGE_HELP_DRAWER,
            page
        }
    },
    Clear: IHelpDrawerClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_HELP_DRAWER_CLEAR,
            propertiesToClear
        }
    };

export const
    ACTION_TOGGLE_HELP_DRAWER = "ACTION_TOGGLE_HELP_DRAWER",
    ACTION_SET_PAGE_HELP_DRAWER = "ACTION_SET_PAGE_HELP_DRAWER",
    ACTION_HELP_DRAWER_CLEAR = "ACTION_HELP_DRAWER_CLEAR";

export interface IToggleHelpDrawerAction {
    type: "ACTION_TOGGLE_HELP_DRAWER";
    isOpen: boolean;
}

export interface IToggleHelpDrawerActionCreator {
    (isOpen: boolean): IToggleHelpDrawerAction;
}

export interface ISetPageAction {
    type: "ACTION_SET_PAGE_HELP_DRAWER";
    page: Page;
}

export interface ISetPageActionCreator {
    (page: Page): ISetPageAction;
}

export interface IHelpDrawerClearAction {
    type: "ACTION_HELP_DRAWER_CLEAR";
    propertiesToClear?: string[];
}

export interface IHelpDrawerClearActionCreator {
    (propertiesToClear?: string[]): IHelpDrawerClearAction;
}

export type HelpDrawerAction =
    IToggleHelpDrawerAction |
    ISetPageAction |
    IHelpDrawerClearAction;
